import React, {useEffect, useState} from 'react';
import Header from '~/components/header/Header';
import Block from '~/components/ui/block/Block';
import MapImage from '~/assets/map.png';
import Button from '~/components/ui/button/Button';
import { styled } from "styled-components";
import apiService from '~/service/apiService';
import RefreshImage from '~/assets/refresh.png';

const LetsStartBlock = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  
  .letsStart_form {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    .form {
      width: unset;
      margin-left: auto;
      margin-right: auto;
      
      a {
        color: #9738FF;
        
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
      }
      
      .wz_btn {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;

        button {
          width: 48%;
        }
      }
    }
    
    label {
      
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
    }
    
    input {
      background: #F5F5F5;
      border-radius: 7px;
      width: 261px;
      display: block;
      border: 0px solid;
      padding: 10px;
      margin-bottom: 12px;
      
      
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
    }
    select {
      background: #F5F5F5;
      border-radius: 7px;
      width: 261px;
      display: block;
      border: 0px solid;
      padding: 10px;
      margin-bottom: 12px;
      
      
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
    }
  }
  .letsStart_right_image {
    flex: 1;
    text-align: center;
    padding-bottom: 60px;
  }
`;

const LinkGroup = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  .refresh {
    img {
      position: absolute;
      margin-left: -30px;
      margin-top: -3px;
    }
  }
`;

const LetsStart = ({jwt, activeStep, btnBackEvent, btnNextEvent, companyId, setTraining_id, redirect, originalTemplateId}) => {

  const [disabledNextStep, setDisabledNextStep] = useState(true);
  const [loading, setLoading] = useState(false);
  const [trainingName, setTrainingName] = useState('');
  const [locations, setLocations] = useState([]);
  const [locationId, setLocationId] = useState(null);

  const createTraining = () => {
    setDisabledNextStep(true);
    setLoading(true);

    if (btnNextEvent && trainingName) {
      const DataForSending = {
        training: {
          title: trainingName
        }
      };

      if (locationId) {
        DataForSending.training.location_ids = [locationId];
      }

      if (originalTemplateId) {
        DataForSending.training.originalTemplateId = originalTemplateId;
      }

      apiService.post(`/companies/${companyId}/trainings`, DataForSending, jwt).then(data => {
        if (data && data?.training) {
          if (redirect == null || redirect == undefined) {
            window.location.href = `/companies/${companyId}/trainings/${data?.training.id}/wizard_edit`;
          } else {
            setTraining_id(data?.training.id);
            setTimeout(() => {
              setDisabledNextStep(false);
              setLoading(false);
              btnNextEvent();
            }, 500);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (trainingName) {
      setDisabledNextStep(false);
    }
  }, [trainingName]);

  useEffect(() => {
    apiService.get(`/companies/${companyId}/locations`, jwt).then(data => {
      if (data && data.locations) {
        setLocations(data.locations);
      }
    });
  }, [companyId, jwt]);

  const GetLocationList = (e)  => {
    e.preventDefault();

    apiService.get(`/companies/${companyId}/locations`, jwt).then(data => {
      if (data && data.locations) {
        setLocations(data.locations);
      }
    });

    return false;
  };

  const dashboardUrl = process.env.REACT_APP_DASHBOARD_BASE_URL || 'https://dashboard.easyllama.com'

  return (
    <div className='wizardWrapper'>
      <div className='header'>
        <Header activeStep={activeStep} />
      </div>
      <div className='wz_container'>
        <Block>
          <LetsStartBlock>
            <div className='letsStart_form'>
              <div className='form'>
                <h3>Let’s start from here</h3>
                <div>
                  <label htmlFor="trainingName">Training name:</label>
                  <input type="text" id="trainingName" name={trainingName} onChange={(e) => setTrainingName(e.target.value)} />
                </div>
                {/*<div>*/}
                {/*  <label htmlFor="state">State:</label>*/}
                {/*  <select id="state" name="state">*/}
                {/*    <option value={1}>California</option>*/}
                {/*  </select>*/}
                {/*</div>*/}
                <div>
                  <label htmlFor="location">Select a location where this course applies:</label>
                  <select id="location" name="location" onChange={(e) => setLocationId(e.target.value)}>
                    <option key={`location_`} value=''>Optional</option>
                    {locations.map(el => {
                      return <option key={`location_${el.id}`} value={el.id}>{el.name}</option>
                    })}
                  </select>
                </div>
                <LinkGroup>
                  <a href={`${dashboardUrl}/companies/${companyId}/locations`} target='_blank' rel="noreferrer">Add new location</a>
                  <a href='/get_policy' onClick={GetLocationList} className='refresh'>
                    <img src={RefreshImage} alt='' />
                    Refresh list</a>
                </LinkGroup>
                <div className='wz_btn'>
                  <Button onClick={btnBackEvent} title='Back' className='' />
                  <Button onClick={createTraining} title={loading ? 'Loading...' : 'Next'} className='primaryBtn' disabled={disabledNextStep} />
                </div>
              </div>
            </div>
            <div className='letsStart_right_image'>
              <img src={MapImage} alt='Map' />
            </div>
          </LetsStartBlock>
        </Block>
      </div>
    </div>
  );
};

export default LetsStart;
